import { type OpenApiSchemaImportProductsSettings } from '../../api/schema';
import { type IntegrationSettings, type SupportedIntegrationSyncTypes } from './types';

export const isIntegrationSettingsForProducts = (
    syncType: SupportedIntegrationSyncTypes,
    data: IntegrationSettings | undefined
): data is OpenApiSchemaImportProductsSettings => Boolean(data && syncType === 'products');
